<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('crudAgenciasEmprego.messages.systemMessage') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table :headers="headers" :items="agencias" :mostrar-inativos="mostrarInativos" :search="search" :loading="loadingtable"
      :loading-text="$t('crudAgenciasEmprego.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="AGENCIASEMPREGO" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudAgenciasEmprego.title')" :token="token" :items="agenciasFiltradas"
          csv-title="agencias_emprego" @search="search = $event">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="3" md="2">
                          <v-text-field v-model="editedItem.cod_agencia"
                            :label="$t('crudAgenciasEmprego.form.fields.codAgencia')"
                            :rules="[codAgenciaRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.nome"
                            :label="$t('crudAgenciasEmprego.form.fields.nome')"
                            :rules="[nomeRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                          <v-switch v-model="editedItem.ativo" class="ma-2"
                            :label="$t('crudAgenciasEmprego.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudAgenciasEmprego.activeYes') : $t('crudAgenciasEmprego.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "../../utils/eventBus";
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    mostrarInativos: false,
    agencias: [],
    editedIndex: -1,
    editedItem: {
      id_agencia_emprego: null,
      cod_agencia: null,
      nome: null,
      ativo: true,
    },
    deletedItem: {},
    defaultItem: {
      id_agencia_emprego: null,
      cod_agencia: null,
      nome: null,
      ativo: true,
    },
  }),
  computed: {
    agenciasFiltradas() {
      if (!this.mostrarInativos) {
        return this.agencias.filter((a) => a.ativo === true || a.ativo === 1);
      }
      return this.agencias;
    },
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudAgenciasEmprego.form.title.create')
        : this.$t('crudAgenciasEmprego.form.title.edit');
    },
    defaultSort() {
      return [
        { value: 'cod_agencia', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaAgencias();
  },
  methods: {

    codAgenciaRules() {
      if (!validador(this.editedItem.cod_agencia, 1, 20, 0, 1)) {
        return this.$t('crudAgenciasEmprego.form.validation.codAgenciaRequired');
      }
      return true;
    },
    nomeRules() {
      if (!validador(this.editedItem.nome, 1, 200, 1, 1)) {
        return this.$t('crudAgenciasEmprego.form.validation.nameRequired');
      }
      return true;
    },
    populaAgencias() {
      apiController.request(apiController.endpoints.getallAgenciasemprego, {
        onSuccess: (response) => {
          this.agencias = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.agencias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('crudAgenciasEmprego.messages.confirmDelete', { nome: item.nome });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteAgenciaemprego, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = {};
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          id_agencia_emprego: this.editedItem.id_agencia_emprego,
          cod_agencia: this.editedItem.cod_agencia,
          nome: this.editedItem.nome,
          ativo: this.editedItem.ativo ? 1 : 0,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertAgenciaemprego, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateAgenciaemprego, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudAgenciasEmprego.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudAgenciasEmprego.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudAgenciasEmprego.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudAgenciasEmprego.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudAgenciasEmprego.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudAgenciasEmprego.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaAgencias();
    },
  },
};
</script>
